declare let grecaptcha: any

const FormSubmit = {
  init(target) {
    if (target) {
      const form = target
      this.validateRecaptcha(form)

      form.addEventListener('submit', (e) => {
        e.preventDefault()
        this.submit(form)
      })
    }
  },

  validateRecaptcha(form) {
    const button = <HTMLButtonElement>form.querySelector('button[type=submit]')
    const recaptchaElement = <HTMLInputElement>document.getElementsByName('g-recaptcha-response')[0]

    if (recaptchaElement != null) {
      grecaptcha.ready(() => {
        // do request for recaptcha token
        // response is promise with passed token

        grecaptcha
          .execute(button.getAttribute('data-siteKey'), { action: 'validate_captcha' })
          .then((token: string) => {
            // add token value to form
            recaptchaElement.value = token
          })
      })
    }
  },

  async submit(form) {
    const button = form.querySelector('button[type=submit]')
    const callout = form.querySelectorAll('.callout')
    const data = new FormData(form)
    const action = form.getAttribute('action')
    const formMethod = form.getAttribute('method')

    if (callout) {
      callout.forEach((el) => el.remove())
    }

    button.disabled = true
    button.classList.add('button--loading')

    fetch(action, {
      method: formMethod,
      body: data,
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.success) {
          this.renderMessage(form, response.message, 'success')
          form.reset()
        } else {
          this.renderMessage(form, response.message, 'error')
        }
        setTimeout(() => {
          button.classList.remove('button--loading')
          button.disabled = false
        }, 150)
      })
      .catch((ex) => {
        this.renderMessage(form, `Server error: ${ex}`, 'error')
      })
  },

  renderMessage(el, message, type) {
    el.insertAdjacentHTML('beforeend', `<div class="callout callout--${type}">${message}</div>`)
  },
}

export default FormSubmit
